// Utility function outside of PermissionManager
import { getLocalValue, IRoleMain, LoacalVariables, MasterPages, TransactionPages } from "./CommonFunctions";

export interface IPermission {
    view?: boolean;
    add?: boolean;
    edit?: boolean;
    list?: boolean;
    remove?: boolean;
    exports?: boolean;
}
export function getPermissions(page: string | MasterPages | TransactionPages): IPermission {
    let objPermissions: IPermission = {
        view: true,
        add: true,
        edit: true,
        list: true,
        remove: true,
        exports: true
    };
    const permissions: Array<any> = getLocalValue(IRoleMain.Permissions, true);
    const currentPage: Array<any> = permissions?.filter((item: any) => item.page?.toLowerCase() === page?.toLowerCase())
    const actions: Array<any> = currentPage && currentPage.length > 0 && currentPage[0].actions;
    if (actions && actions.length > 0) {
        actions.forEach((permission: any) => {
            const label = permission.operation?.toLowerCase() as keyof IPermission;
            if (objPermissions.hasOwnProperty(label)) {
                objPermissions[label] = permission.permission;
            }
        });
    }

    return objPermissions;
}



export class AllPermissions {
    private static instance: AllPermissions;
    private static leadPermission: IPermission;
    private static MeetingPermission: IPermission
    private static ContactPermission: IPermission
    private static CallPermission: IPermission
    private static TaskPermission: IPermission
    private static UserPermission: IPermission
    private static RolePermission: IPermission
    private static NotePermission: IPermission
    private static ProductsPermission: IPermission
    private static DealPermission: IPermission
    private static QuoationPermission: IPermission
    private static EstimationPermission: IPermission
    private static WorkOrdersPermission: IPermission
    private static PaymentsPermission: IPermission
    private static EmailPermission: IPermission
    private constructor() {
        AllPermissions.leadPermission = getPermissions(MasterPages.Leads);
        AllPermissions.MeetingPermission = getPermissions(MasterPages.Meetings);
        AllPermissions.ContactPermission = getPermissions(MasterPages.Contacts);
        AllPermissions.CallPermission = getPermissions(MasterPages.Call);
        AllPermissions.TaskPermission = getPermissions(MasterPages.Tasks);
        AllPermissions.UserPermission = getPermissions(MasterPages.Users);
        AllPermissions.RolePermission = getPermissions(MasterPages.Roles);
        AllPermissions.NotePermission = getPermissions(MasterPages.Notes);
        AllPermissions.ProductsPermission = getPermissions(MasterPages.Products);
        AllPermissions.DealPermission = getPermissions(MasterPages.Deal);
        AllPermissions.QuoationPermission = getPermissions(TransactionPages.Quotations);
        AllPermissions.EstimationPermission = getPermissions(TransactionPages.Estimates);
        AllPermissions.WorkOrdersPermission = getPermissions(TransactionPages.WorkOrders);
        AllPermissions.PaymentsPermission = getPermissions(TransactionPages.Payments);
        AllPermissions.EmailPermission = getPermissions(TransactionPages.Email);

    } // private constructor to prevent instantiation

    static getInstance(): AllPermissions {
        if (!AllPermissions.instance) {
            AllPermissions.instance = new AllPermissions();

        }
        return AllPermissions.instance;
    }

    public static get getLeadPermission(): IPermission {
        return AllPermissions.leadPermission
    }

    public static get getContactPermission(): IPermission {
        return AllPermissions.ContactPermission
    }

    public static get getMeetingPermission(): IPermission {
        return AllPermissions.MeetingPermission
    }

    public static get getTaskPermission(): IPermission {
        return AllPermissions.TaskPermission
    }

    public static get getCallPermission(): IPermission {
        return AllPermissions.CallPermission
    }

    public static get getUserPermission(): IPermission {
        return AllPermissions.UserPermission
    }

    public static get getNotesPermission(): IPermission {
        return AllPermissions.NotePermission
    }

    public static get getRolePermission(): IPermission {
        return AllPermissions.RolePermission
    }

    public static get getProductPermission(): IPermission {
        return AllPermissions.ProductsPermission
    }

    public static get getDealPermission(): IPermission {
        return AllPermissions.DealPermission
    }

    public static get getEstimationPermission(): IPermission {
        return AllPermissions.EstimationPermission
    }

    public static get getQuotationPermission(): IPermission {
        return AllPermissions.QuoationPermission
    }

    public static get getPaymentPermission(): IPermission {
        return AllPermissions.PaymentsPermission
    }

    public static get getWorkOrderPermission(): IPermission {
        return AllPermissions.WorkOrdersPermission
    }

    public static get getEmailPermission(): IPermission {
        return AllPermissions.EmailPermission
    }

}









// // Utility function outside of PermissionManager
// import { getLocalValue, IRoleMain, LoacalVariables, MasterPages } from "./CommonFunctions";

// export interface IPermission {
//     view?: boolean;
//     add?: boolean;
//     edit?: boolean;
//     list?: boolean;
//     delete?: boolean;
//     exports?: boolean;
// }



// export function getPermissions(page: string | MasterPages, pageType: IRoleMain): IPermission {
//     const userType: any = getLocalValue(LoacalVariables.UserType);
//     if (userType !== 'admin') {
//         return {
//             view: true,
//             add: true,
//             edit: true,
//             list: true,
//             delete: true,
//             exports: true
//         };
//     }

//     let objPermissions: IPermission = {
//         view: false,
//         add: false,
//         edit: false,
//         list: false,
//         delete: false,
//         exports: false
//     };

//     const roles: any = getLocalValue(IRoleMain.Roles, true);
//     const pageTypes: Array<any> = roles?.roles
//         ?.filter((page: any) => page?.type?.toLowerCase() === pageType?.toLowerCase());

//     const subPage: Array<any> = pageTypes && pageTypes[0]?.pages
//         ?.filter((sub: any) => sub?.type?.toLowerCase() === page?.toLowerCase());

//     const permissions: Array<any> = subPage && subPage.length > 0 && subPage[0].permissions;

//     if (permissions && permissions.length > 0) {
//         permissions.forEach((permission: any) => {
//             const label = permission.label?.toLowerCase() as keyof IPermission;
//             if (objPermissions.hasOwnProperty(label)) {
//                 objPermissions[label] = permission.permission;
//             }
//         });
//     }

//     return objPermissions;
// }
